/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2020-08-15 16:55:23
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\uploadVideoForXj\uploadService.js
 * @Description:视频上传公共服务
 */

angular.module('editCenUploadVideoForXjModule', []).factory('editCenUploadVideoForXjService', [
    '$q',
    '$state',
    'modalDialog',
    'trsHttpService',
    'localStorageService',
    function ($q, $state, modalDialog, trsHttpService, localStorageService) {
        return {
            // 上传图片配置项
            singleImageOption: {
                title: '图片',
                extensions: 'gif,jpg,jpeg,png',
                mimeTypes: '.gif,.jpg,.jpeg,.png',
            },
            // 上传视频单独视频配置项
            singleVideoOption: {
                showModal: false, // 是否展示弹窗
                auto: true, // 自动上传
                multiple: false,
                accept: {
                    title: '视频',
                    extensions: 'mp4,mov,mpeg,avi',
                    mimeTypes: 'video/mp4,video/mpeg,video/x-msvideo,video/quicktime',
                },
            },
            // 上传音频单独视频配置项
            singleAudioOption: {
                showModal: false, // 是否展示弹窗
                auto: true, // 自动上传
                multiple: false,
                accept: {
                    title: '音频',
                    extensions: 'mp3,flac,wav,wma',
                    mimeTypes: 'audio/mpeg,audio/x-flac,audio/x-wav,audio/x-ms-wma',
                },
            },
            videoPollInterval: 1000 * 15, // 视频轮训查询间隔
            // 视频状态
            videoDraftStatus: { // 采编视频处理状态
                '-2': '转码失败',
                0: '转码中',
                1: '转码完成',
                2: '快编中',
                3: '快编失败',
            },

            /**
             * [registerVideo description]是上传视频后注册视频
             * @param   {[obj]}  file   [file description]上传后的文件
             * @param   {[obj]}  user   [user description]当前用户登录信息
             * @param   {[str]}  token  [token description]用户token
             * @return  {[promise]}         [return description]promise
             */
            registerVideo: function (file, user, token) {
                var defer = $q.defer();
                var params = {
                    tempUrl: file.path,
                    tenantId: angular.isObject(user) ? user.TENANTID : user,
                    userId: token,
                    videoName: file.name,
                };
                trsHttpService.httpServer('/transfer/aav/video/uploadByTempUrl', params, 'post').then(
                    function (data) {
                        defer.resolve(data);
                    },
                    (error) => {
                        defer.reject(error);
                    }
                );
                return defer.promise;
            },

            /**
             * [video description] 获取视频信息
             * @param   {[object]}  video  [video description] 视频信息
             * @return  {[type]}           [return description]
             */
            getVideoMark: function (video) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_videoInterfacesEncapsulation',
                    methodname: 'getVideoInfoAndUpdate',
                    audioVideoId: angular.isObject(video) ? video.AUDIOVIDEOID : video, // 适配编辑器
                    plateFormFlag: 'BDVideoObject',
                };
                params.audioVideoId = params.audioVideoId.toString();
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if (data.transcodes && data.status === -2) {
                        // 表示转码失败
                        defer.reject(data);
                    } else {
                        defer.resolve(data);
                    }
                }, function(data) {
                    defer.reject(data);
                });
                return defer.promise;
            },

            /**
            * [exampleVideo description] 视频检测
            * @param   {[type]}  videoInfo     [videoInfo description] 本地存储的视频信息
            * @param   {[type]}  list          [list description] 稿件对象
            * @param   {[type]}  id            [id description] 当前稿件ID
            * @param   {[str]}  name           [name description] 缓存名称
            * @return  {[promise]}             [return description]
            */
            exampleVideo: function (videoInfo, list, id, name) {
                var defer = $q.defer();
                if (!videoInfo || !videoInfo[name] || !videoInfo[name][id]) {
                    // 不存在当前ID下的视频就不去比对
                    defer.reject();
                    return defer.promise;
                }
                if (list.VIDEOREL[0].AUDIOVIDEOID != videoInfo[name][id][0]) {
                    modalDialog.confirmModal(
                        '音视频恢复',
                        '是否恢复到上一次操作过的音视频?',
                        function () {
                            defer.resolve(videoInfo[name][id]);
                        },
                        function () {
                            defer.reject();
                        }
                    );
                } else {
                    defer.reject();
                }
                return defer.promise;
            },

            /**
            * [editVideo description]编辑视频
            * @param   {[obj]}   list     [list description]稿件对象
            * @return  {[promise]}        [return description]promise对象
            */    
            editVideo: function (list) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_videoInterfacesEncapsulation',
                    methodname: 'getKBUrl',
                    audioVideoId: angular.isObject(list) ? list.VIDEOREL[0].AUDIOVIDEOID : list,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    defer.resolve(data);
                }, function(data) {
                    defer.reject(data);
                });
                return defer.promise;
            },

            /**
             * [cancelEditVideo description]取消快编
             * @param  {[obj]} list [description]稿件信息
             * @return {[type]}     [description]
             */
            cancelEditVideo: function (list) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_videoInterfacesEncapsulation',
                    methodname: 'cancelQuickEdit',
                    audioVideoId: angular.isObject(list) ? list.VIDEOREL[0].AUDIOVIDEOID : list,
                    plateFormFlag: 'BDVideoObject',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    defer.resolve(data);
                }, function(data) {
                    defer.reject(data);
                });
                return defer.promise;
            },

            /**
             * [clearDraftVideoInfo description]清除稿件的视频信息
             * @param   {[str]}  trench  [trench description]渠道名
             * @param   {[str]}  id      [id description]稿件id
             * @return  {[undefined]}    [return description]
             */
            clearDraftVideoInfo: function (trench, id) {
                var videoUploadInfo = localStorageService.get('videoUploadInfo');
                if (!videoUploadInfo || !videoUploadInfo[trench] || !videoUploadInfo[trench][$state.params[id]]) {
                    return;
                }
                delete videoUploadInfo[trench][$state.params[id]];
                localStorageService.set('videoUploadInfo', videoUploadInfo);
            },

            /**
             * [registerWordToAudio description]注册文字转音频任务
             * @param   {[obj]}     params   [params description] 请求参数
             * @return  {[promise]}          [return description] promise
             */
            registerWordToAudio: function (params) {
                var defer = $q.defer();
                trsHttpService.httpServer('/transfer/aav/audio/commitTask', params, 'post').then(function (data) {
                    defer.resolve(data);
                }, function(data) {
                    defer.reject(data);
                });
                return defer.promise;
            },

            /**
             * [getAudioInfo description] 获取音频转换信息
             * @param   {[obj]}     params   [params description] 请求参数
             * @return  {[promise]}          [return description] promise
             */
            getAudioInfo: function (params) {
                var defer = $q.defer();
                trsHttpService.httpServer('/transfer/aav/audio/getTaskDetail', params, 'get').then(function (data) {
                    if (data.datas && data.datas.status === '-2') {
                        // 表示转换出问题
                        defer.reject(data);
                    } else {
                        defer.resolve(data);
                    }
                }, function(data) {
                    defer.reject(data);
                });
                return defer.promise;
            },

            // /**
            //  * [keepCheckedStatus description]保存至个人素材单选框状态
            //  *
            //  * @param   {[type]}  status  [status description]
            //  *
            //  * @return  {function}        [return description]
            //  */
            keepCheckedStatus: function(status) {
                return status = !status;
            },

            /**
             * [exampleVideoBeforeSave description] 保存前检查视频
             * @param   {[obj]}     scope   [params description] 对应控制器scope对象
             * @return  {[promise]}          [return description] promise
             */
            exampleVideoBeforeSave(scope){
                var defer = $q.defer();
                if (!scope.list.VIDEOREL.length) {
                    modalDialog.alertType('保存失败', '需要上传一个视频', 'warning', false);
                    defer.reject();
                } else if (scope.list.videoStatus && scope.list.videoStatus === '快编中') {
                    modalDialog.alertType('保存失败', '视频快编中无法保存', 'warning', false);
                    defer.reject();
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }
        };
    },
]);
